<template>
  <teleport to="body">
    <v-overlay
      v-model="loading.isLoading"
      class="loading-overlay"
      persistent
      opacity="0.7"
      transition="fade-transition"
      scroll-strategy="block"
      :contained="false"
    >
      <div class="loading-content">
        <v-progress-circular indeterminate size="64" width="4" color="primary" />
        <div v-if="loading.message" class="loading-message">
          {{ loading.message }}
        </div>
      </div>
    </v-overlay>
  </teleport>
</template>

<script setup lang="ts">
import { useLoadingStore } from '@/stores/loading';
const loading = useLoadingStore();
</script>

<style scoped>
.loading-overlay {
  z-index: 9999;
}

/* Ensure the scrim covers the entire viewport */
:deep(.v-overlay__scrim) {
  position: fixed !important;
  inset: 0 !important;
}

/* Ensure the content container fills the viewport and centers its children */
:deep(.v-overlay__content) {
  position: fixed !important;
  inset: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 40vh;
}

.loading-message {
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
</style>
